import React, { PureComponent } from "react";
import classNames from "../../utils/classnames";

export class TabPanel extends PureComponent {
  render() {
    const { className, children, ...others } = this.props;
    const cls = classNames({
      "weui-tab__panel": true
    }, className);

    return (
      <div role="tabpanel" className={ cls } { ...others }>
        { children }
      </div>
    );
  }
}
